import type { MiddlewareAPI } from 'redux';
import 'rxjs/add/observable/of';
import 'rxjs/add/observable/timer';
import 'rxjs/add/operator/switchMap';
import 'rxjs/add/operator/mergeMap';
import type { ActionsObservable } from 'redux-observable';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';
import 'rxjs/add/operator/debounce';
import { list as listArticles } from '@atlassian/jira-servicedesk-knowledge-services/src/services/articles/index.tsx';
import type {
	ListArticlesResponse,
	Expand,
	OrderBy,
} from '@atlassian/jira-servicedesk-knowledge-services/src/services/rest/articles/index.tsx';
import type { CategoryId } from '@atlassian/jira-servicedesk-knowledge-services/src/types';
import { SEARCH_ARTICLES } from '../../state/actions/search-articles';
import { getBaseUrl } from '../../state/selectors/base';
import type { State } from '../../state/types';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const epic = (action$: ActionsObservable<any>, store: MiddlewareAPI<State>) =>
	action$.ofType(SEARCH_ARTICLES).mergeMap(() => getBaseUrl(store.getState()));

type SearchStreamArgs = {
	projectId: number;
	activationId: string;
	/**
	 * If you want to return all articles term needs to be undefined so
	 * the following service API call does not set query param "filter".
	 */
	term?: string;
	searchOnEmptyTerm?: boolean;
	limit?: number;
	expansions?: Expand[];
	orderBy?: OrderBy;
	categoryId: CategoryId;
};

export const createSearchStream = (activationId: string) => {
	const stream$ = new Subject();
	// @ts-expect-error - TS2684 - The 'this' context of type 'Observable<unknown>' is not assignable to method's 'this' of type 'Observable<{ term: any; projectId: any; limit: any; searchOnEmptyTerm: any; categoryId: any; expansions: any; orderBy: any; }>'.
	const results$ = stream$
		// @ts-expect-error - TS2345 - Argument of type '({ term }: { term: any; }) => Observable<number>' is not assignable to parameter of type '(value: unknown) => SubscribableOrPromise<number>'.
		.debounce(({ term }) => Observable.timer(term ? 300 : 0))
		.switchMap(({ term, projectId, limit, searchOnEmptyTerm, categoryId, expansions, orderBy }) => {
			if (!searchOnEmptyTerm && !term) {
				const empty: ListArticlesResponse = {
					results: [],
					totalSize: 0,
					start: 0,
					limit: 0,
					size: 0,
					categoriesSupported: true,
				};
				return Observable.of(empty);
			}
			return listArticles(projectId, activationId, {
				limit,
				categoryId,
				query: term,
				expand: expansions,
				orderby: orderBy,
			});
		});

	return {
		search: (args: SearchStreamArgs) => stream$.next(args),
		results$,
	};
};
